export default __webpack_public_path__ + "static/media/need_to_see_your_work.1a1534bb.svg";